export default __webpack_public_path__ + "static/media/logo-databit.029a22e5.png";